import { NotificationMessageModal } from "@design-system";
import React, { FC } from "react";

export type NotificationMessageModalContainerProps = {
  message: string;
  handleOkClick: () => void;
};

export const NotificationMessageModalContainer: FC<NotificationMessageModalContainerProps> = (
  props
) => <NotificationMessageModal {...props}></NotificationMessageModal>;
